// config.js

const config = {
  // Authentication API Configuration
  AUTH_API_ADDRESS: 'https://admin.horoboro.com/api',
  BACKEND_API_ADDRESS: 'https://luxottica.parallelia.com/api',

  // Other configuration options (add as needed)
  // apiTimeout: 30000,
  // environment: 'production',
};

export default config;